export default function getGraphCmsImageUrl(coverImage, width = 720) {
  return coverImage && `https://media.graphcms.com/resize=w:${width}/${coverImage.handle}`;
}
